const TOOLTIP_PREFIX = 'Plazo de confirmación:';

// Figma 6736:47435 — the tooltip is a bold title ("Plazo de confirmación: …")
// plus a regular-weight description sentence, and the description text is
// keyed off the same critical/warning bucket as the row's icon color
// (`URGENCY_VISUAL_MAP`), not off the exact day count.
const DESCRIPTION_BY_URGENCY: Record<string, string> = {
  Urgent: 'Revísalo cuanto antes para evitar que desaparezca.',
  Overdue: 'Revísalo cuanto antes para evitar que desaparezca.',
  DueSoon:
    'El registro aún está dentro del plazo, pero se acerca su fecha límite.',
};

// Builds the row urgency tooltip title from the server-provided values.
// Returns null when there is no active deadline for the row, which the
// template reads as "render no icon/tooltip at all".
export function formatUrgencyTooltip(
  daysRemaining: number | null,
  urgency: string,
): string | null {
  if (daysRemaining === null) {
    return null;
  }

  // An expired record never shows a (negative) day count.
  if (urgency === 'Overdue') {
    return `${TOOLTIP_PREFIX} vencido`;
  }

  if (daysRemaining === 0) {
    return `${TOOLTIP_PREFIX} hoy`;
  }

  if (daysRemaining === 1) {
    return `${TOOLTIP_PREFIX} 1 día`;
  }

  return `${TOOLTIP_PREFIX} ${daysRemaining} días`;
}

// Builds the row urgency tooltip's description line. Only meaningful when
// formatUrgencyTooltip() above returned a title for the same row — callers
// gate on that, so an unrecognised urgency here just falls back to ''.
export function formatUrgencyTooltipDescription(urgency: string): string {
  return DESCRIPTION_BY_URGENCY[urgency] ?? '';
}
